import './project-detail.scss';

import { OligoItem, ProjectItem, ProjectItemOrNull } from '../../models';

type ProjectDetailConfig = {
  tombstoneText: string;
  tombstoneStart: number;
};
export interface ProjectDetailOptions {
  project: ProjectItemOrNull;
  config: ProjectDetailConfig | null;
}

type OligoDetailDimension = {
  width?: number;
  height?: number;
  tombstone: boolean;
};

export class ProjectDetailController implements ng.IComponentController, ProjectDetailOptions {

  public project: ProjectItemOrNull = null;
  public config: ProjectDetailConfig | null = null;
  public oligoDetailDimensions: OligoDetailDimension[] = [];

  public $onDestroy(): void {
    this.project = null;
  }

  public onOligoComponentLayout(oligo: { data: OligoItem }): void {
    // this will get bound on link
  }

}

export const PROJECT_DETAIL_NAME: string = 'projectDetail';
export const ProjectDetail: ng.IDirectiveFactory = ($timeout: ng.ITimeoutService, $document: ng.IDocumentService, $window: ng.IWindowService) => {
  return {
    template: require('./project-detail.tpl.html'),
    controller: ProjectDetailController,
    controllerAs: 'projectDetail',
    restrict: 'E',
    bindToController: true,
    transclude: true,
    scope: {
      project: '<',
      config: '<',
    },
    link: ($scope: ng.IScope, element: JQLite, attrs: ng.IAttributes, ctrl?: ng.IController) => {
      const controller: ProjectDetailController = ctrl as ProjectDetailController;
      const { oligoDetailDimensions } = controller;
      let scrollInAction: boolean = false;
      const isHiddenFromViewport = (rect: ClientRect): boolean => {
        return rect.bottom < 0 || rect.top > ($window.innerHeight || ($document[0] as Document).documentElement.clientHeight);
      };
      // what are we trying to achieve here you ask? well, what we want to
      // do is replace elements not within the viewport with 'tombstones'
      // so that we don't populate the dom with too much components the user
      // doesn't even see. so if it is within the viewport, we put
      // the actual element back in place of the tombstone
      const needsTombstones = (project: ProjectItemOrNull, config: ProjectDetailConfig | null): boolean => project && config && config.tombstoneStart ?
        project.oligos.length > config.tombstoneStart : false;
      const framesPerSecond: number = 60 / 1000;
      const tombstoneListener = () => {
        if (scrollInAction || !needsTombstones(controller.project, controller.config)) {
          return;
        }
        $timeout(() => {
          if (controller.project) {
            controller.project.oligos.forEach((oligo, index) => {
              const oligoDetailRect = element.find(`#project-detail__oligo_${oligo.id}`)[0].getBoundingClientRect();
              let dimension: OligoDetailDimension | undefined = oligoDetailDimensions[index];
              const tombstone: boolean = isHiddenFromViewport(oligoDetailRect);
              if (!dimension) {
                dimension = {
                  tombstone,
                };
              } else {
                dimension.tombstone = tombstone;
              }
              oligoDetailDimensions[index] = dimension;
            });
          }
          scrollInAction = false;
        }, framesPerSecond);
        scrollInAction = true;
      };

      const updateMatchingOligosWithNoDimension = (reference: OligoItem, referenceDim: OligoDetailDimension): void => {
        const hasSameDisplaySetting = (oligo2: OligoItem) => {
          return (reference.id !== oligo2.id) &&
                 (reference.configDisplayType === oligo2.configDisplayType) &&
                 (reference.displayType === oligo2.displayType);
        };
        const { project } = controller;
        if (!project) {
          return;
        }
        project.oligos.filter(hasSameDisplaySetting)
          .map((oligo) => oligoDetailDimensions[oligo.index])
          .filter((dimension) => dimension && !dimension.height && !dimension.width)
          .forEach((dimension) => {
            dimension.height = referenceDim.height;
            dimension.width = referenceDim.width;
          });
      };

      const onOligoComponentLayout = (oligo: OligoItem): void => {
        const { id: oligoId, index } = oligo;
        const oligoDetailJQ: JQuery<HTMLElement> = element.find(`#project-detail__oligo_${oligoId}`);
        if (oligoDetailJQ.length > 0) {
          const rect: ClientRect = oligoDetailJQ[0].getBoundingClientRect();
          let dimension = oligoDetailDimensions[index];
          dimension = {
            width: rect.width,
            height: rect.height,
            tombstone: dimension ? dimension.tombstone : false,
          };
          oligoDetailDimensions[index] = dimension;
          // since we lazy render components,
          // we want to make sure that tombstone placeholder
          // dimensions are updated with the same sizes as
          // their full rendered counterparts
          updateMatchingOligosWithNoDimension(oligo, dimension);
        }
      };
      controller.onOligoComponentLayout = (oligo: { data: OligoItem }): void => {
        $timeout(() => {
          onOligoComponentLayout(oligo.data);
          tombstoneListener();
        });
      };

      ['scroll', 'resize'].forEach((eventName) => {
        $window.addEventListener(eventName, tombstoneListener);
      });
      element.on('$destroy', () => {
        ['scroll, resize'].forEach((eventName) => {
          $window.removeEventListener(eventName, tombstoneListener);
        });
      });

      const bootstrap = () => {
        const { project, config } = controller;
        const { tombstoneStart } = config as ProjectDetailConfig;
        const { oligos } = project as ProjectItem;
        // before this component is rendered on-screen,
        // we want to make sure that elements that should
        // appear after the tombstone setting are initially
        // rendered with tombstone placehodlers first
        oligos.forEach((oligo) => {
          oligoDetailDimensions[oligo.index] = {
            tombstone: oligo.index >= tombstoneStart,
          };
        });
        $timeout(() => {
          // components that appear before the tombstone
          // threshold should be rendered in full
          oligos.filter((oligo) => oligo.index < tombstoneStart)
                .forEach(onOligoComponentLayout);
        });
      };
      bootstrap();
    },
  };
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0-0!./src/main/script/components/project-detail/project-detail.ts